import { Info, Place as PlaceIcon } from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { t } from "i18next";
import React from "react";
import { iresoftColors } from "../../../theme/ireColors";

interface PlaceCardProps {
  place: any;
  onClick: () => void;
}

const PlaceCard: React.FC<PlaceCardProps> = ({ place, onClick }) => (
  <Card
    onClick={onClick}
    sx={{
      flex: "0 0 200px",
      minWidth: { xs: 150, sm: 200 },
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      boxShadow: 3,
      border: "solid 1px rgba(0,0,0,0.15)",
      borderRadius: 2,
      transition: "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
      transform: "scale(1)",
      "&:hover": {
        boxShadow: 6,
        transform: "scale(1.05)",
        zIndex: 10,
      },
    }}
    data-place-id={place.id}
  >
    {place.image && (
      <Box
        sx={{
          height: 150,
          width: "100%",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          backgroundImage: `url(data:image/jpeg;base64,${place.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
    )}

    <CardContent
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 0.1,
        height: "55%",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        sx={{ p: 1, borderRadius: 1, mt: -1.5 }}
      >
        <PlaceIcon
          fontSize="small"
          sx={{ fontSize: 18, color: iresoftColors.iresoftRed, opacity: 0.9 }}
        />
        <Typography variant="h6">{place.placeName}</Typography>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        sx={{ p: 1, borderRadius: 1, mt: -1.5 }}
      >
        <Typography variant="subtitle1" color="text.secondary">
          {place.title || ""}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" sx={{ p: 1, borderRadius: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {place.text && place.text.length > 50
            ? place.description.slice(0, 50) + "..."
            : place.description || ""}
        </Typography>
      </Box>
    </CardContent>

    <Box position="absolute" top={8} right={8}>
      <Tooltip title={t("pages.historyReading.tooltip.showMore")}>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          sx={{ color: iresoftColors.white }}
        >
          <Info
            sx={{
              fontSize: "16px",
              opacity: 0.7,
              mt: -2,
              mr: -0.5,
              transition: "opacity 0.2s ease-in-out",
              "&:hover": {
                opacity: 1,
              },
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  </Card>
);

export default React.memo(PlaceCard);
